import { doc, setDoc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase/config";

export const saveSettings = async (data) => {
  const uid = auth.currentUser?.uid;

  // Prevent errors when the user is not yet available
  if (!uid) return;

  await setDoc(doc(db, "gyms", uid), data, {
    merge: true,
  });
};

export const getSettings = async () => {
  const uid = auth.currentUser?.uid;

  // Prevent errors on page refresh
  if (!uid) return null;

  const snapshot = await getDoc(doc(db, "gyms", uid));

  if (!snapshot.exists()) return null;

  return snapshot.data();
};
